import { render, staticRenderFns } from "./certificate-filters-dates.vue?vue&type=template&id=639dfd35&scoped=true"
import script from "./certificate-filters-dates.vue?vue&type=script&lang=js"
export * from "./certificate-filters-dates.vue?vue&type=script&lang=js"
import style0 from "./certificate-filters-dates.vue?vue&type=style&index=0&id=639dfd35&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639dfd35",
  null
  
)

export default component.exports